import { Component, OnInit } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { PermissionService } from '../../../shared/services/permission.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { UserUrl } from '../../../shared/urls/user.url';
import { BaseUrl } from '../../../shared/urls/base.url';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { UserType } from '../../../shared/constants/permission';
import { AppMessages } from '../../../shared/constants/messages';
import { UserModel } from '../../../models/user/user.model';

@Component({
  selector: 'add-user',
  templateUrl: './add-user.component.html'
})
export class AddUserComponent implements OnInit {
  public addUserForm: FormGroup;
  public userModel = new UserModel('', '', '', '', '', '', '', '', '');
  public isRequiredRegistrationNumber: boolean = false;
  public defaultSelectOption = null;
  public titleData = [];
  public roleData = [];
  public emailDomainData = [];

  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private baseService: BaseService,
    private permissionService: PermissionService,
    public dialogService: DialogService) {
    this.createForm();
  }

  ngOnInit() {
    this.getNewUserInit();
    this.getRoles();
  }
  getRoles() {
    let url = UserUrl.GET_ROLES;
    this.roleData = [];
    this.baseService.getData(url).subscribe(
      (result) => {
        if (result) {
          this.roleData = result.json();
        }
      }
    );
  }
  getNewUserInit() {
    let url = UserUrl.CREATE_NEW_USER_URL;
    this.titleData = [];
    this.emailDomainData = [];
    this.roleData = [];
    this.baseService.getData(url).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          data.tittles.forEach(element => {
            this.titleData.push({ id: element.id, name: element.name });
          });
          data.emailDomains.forEach(element => {
            this.emailDomainData.push({ id: element.id, name: element.name });
          });
        }
      }
    );
  }

  createForm() {
    this.addUserForm = this.formBuilder.group({
      TitleId: [null],
      FirstName: ['', [Validators.required]],
      SureName: ['', [Validators.required]],
      Email: ['', [Validators.required]],
      EmailDomainId: [null, [Validators.required]],
      RegistrationNumber: [''],
      RoleId: ['', [Validators.required]],
      CallBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
    });
  }

  onRoleChange() {
    let selectedRoleId = this.addUserForm.value.RoleId;
    var selectedRoleName = this.roleData.find(c=>c.id == selectedRoleId).code;

    if (selectedRoleName === UserType.Nurse || selectedRoleName === UserType.Practitioner) {
      this.isRequiredRegistrationNumber = true;
      ValidationService.attachRequired(this.addUserForm.controls['RegistrationNumber'], []);
    } else {
      this.isRequiredRegistrationNumber = false;
      ValidationService.removeRequired(this.addUserForm.controls['RegistrationNumber'], []);
    }
  }

  resetFormData (ngForm) {
    ngForm.resetForm();
    this.addUserForm.reset();
  }


  onSubmit(ngForm) {
    if (this.addUserForm.dirty && this.addUserForm.valid) {
      let url = UserUrl.CREATE_NEW_USER_URL;
      this.baseService.postData(url, this.addUserForm.value).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.resetFormData(ngForm);
            this.createForm();
            this.dialogService.openSuccessDialog({ message: data.message });
          }
        },
        error => {

        }
      );
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/add-user/add-user.component.ts